module.exports = "/_next/static/images/sellers_1_ru-bd9673ca012d744fafa387091da37d08.png";